import React, { ReactElement } from 'react'
import { Tabs, Tab } from '@mui/material'

export interface TabItem {
  label: string
  icon?: string | ReactElement
  content: React.ReactNode
}

interface TabsMenuProps {
  value: number
  onChange: (event: React.SyntheticEvent, newValue: number) => void
  tabs: TabItem[]
}

const tabStyle = (isActive: boolean) => ({
  textTransform: 'none',
  minHeight: 40,
  bgcolor: isActive ? '#fff' : 'transparent',
  borderRadius: 1,
  mr: 1,
  transition: 'all 0.2s ease-in-out',
  '&.Mui-selected': {
    fontWeight: 600,
    color: 'inherit',
    boxShadow: '0px 2px 6px rgba(0,0,0,0.15)'
  },
  '&:hover': {
    bgcolor: isActive ? '#fff' : '#e9ecef'
  }
})

export const TabsMenu: React.FC<TabsMenuProps> = ({
  value,
  onChange,
  tabs
}) => {
  return (
    <Tabs
      value={value}
      onChange={onChange}
      aria-label="Dynamic Tabs"
      variant="standard"
      sx={{
        bgcolor: '#f4f6f8',
        borderRadius: 1,
        minHeight: 40,
        '& .MuiTabs-indicator': {
          display: 'none'
        },
        padding: '4px',
        width: 'fit-content'
      }}
    >
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          icon={tab.icon}
          iconPosition="start"
          label={tab.label}
          sx={tabStyle(value === index)}
        />
      ))}
    </Tabs>
  )
}
